import { parseDataAttr, toggleClasses } from "./utils";

export class Toggle {
  constructor() {
    this.overlay = document.querySelector("[data-body-overlay]");
    this.toggle = null;
    this.targets = null;
    window.addEventListener("click", this.onWindowClick.bind(this), false);
    window.addEventListener("change", this.onWindowChange.bind(this), false);
    console.log("Toggle initialised");
  }

  onWindowClick(event) {
    // If _toggle is set we need to check for an outside click and close any toggles first
    if (this.toggle) {
      if (!this.toggle.contains(event.target) && this.targets) {
        let clickInsideTargets = false;
        for (let key in this.targets) {
          if (this.targets.hasOwnProperty(key)) {
            clickInsideTargets = this.targets[key].contains(event.target) ? true : false;
            if (clickInsideTargets) break;
          }
        }
        if (!clickInsideTargets) {
          this.toggleElement(this.toggle);
        }
      }
    }

    // Check if this is a toggle request
    let toggle = event.target.closest("[data-toggle-classes]");
    if (!toggle) return;

    // Prevent default link behaviour
    event.preventDefault();

    // Toggle element
    this.toggleElement(toggle);
  }

  onWindowChange(event) {
    // Check if this is a toggle change
    let toggle = event.target.closest("[data-toggle]");
    if (!toggle) return;

    // If there are target(s) toggle classes on them, otherwise just toggle classes on the toggle
    let targetsSelector = toggle.getAttribute("data-toggle");
    let targets = targetsSelector ? document.querySelectorAll(targetsSelector) : false;

    if (targets) {
      let selectedOption = toggle.options[toggle.selectedIndex] || false;
      let toggleElement = parseDataAttr(selectedOption, "data-toggle-value", toggle.value);

      for (let key in targets) {
        if (targets.hasOwnProperty(key)) {
          if (toggleElement) {
            targets[key].classList.remove("hidden");
          } else {
            targets[key].classList.add("hidden");
          }
        }
      }
    }
  }

  toggleElement(toggle) {
    toggle = toggle || false;
    if (!toggle) return;

    // Reset outside click variables
    let isAnAutoClose = this.toggle ? true : false;
    this.toggle = null;
    this.targets = null;

    // Get classes to toggle
    let classes = toggle.getAttribute("data-toggle-classes") || "";

    // If there are target(s) toggle classes on them, otherwise just toggle classes on the toggle
    let targetsSelector = toggle.getAttribute("data-toggle-target");
    let targets = targetsSelector ? document.querySelectorAll(targetsSelector) : false;

    if (targets) {
      for (let key in targets) {
        if (targets.hasOwnProperty(key)) {
          toggleClasses(targets[key], classes);
        }
      }
    } else {
      toggleClasses(toggle, classes);
    }

    // Overlay
    if (this.overlay && toggle.hasAttribute("data-toggle-overlay")) {
      this.overlay.classList.toggle("is-open");
    }

    // Enable autoclose
    if (!isAnAutoClose && toggle.hasAttribute("data-toggle-autoclose")) {
      this.toggle = toggle;
      this.targets = targets;
    }
  }
}
